import { useQuery } from '@tanstack/react-query';
import { ConstructionReportsService } from '../services/construction-reports.service';
import type { ReportFilters } from '../types/construction-reports.types';

export function useConstructionReportOverview(companyId: string, projectId?: string) {
  return useQuery({
    queryKey: ['construction-report-overview', companyId, projectId],
    queryFn: () => ConstructionReportsService.getOverview(companyId, projectId),
    enabled: !!companyId,
  });
}

export function useProgressReport(companyId: string, filters: ReportFilters) {
  return useQuery({
    queryKey: ['construction-progress-report', companyId, filters],
    queryFn: () => ConstructionReportsService.getProgressReport(companyId, filters),
    enabled: !!companyId,
  });
}

export function useQaReport(companyId: string, filters: ReportFilters) {
  return useQuery({
    queryKey: ['construction-qa-report', companyId, filters],
    queryFn: () => ConstructionReportsService.getQaReport(companyId, filters),
    enabled: !!companyId,
  });
}

export function useCostReport(companyId: string, filters: ReportFilters) {
  return useQuery({
    queryKey: ['construction-cost-report', companyId, filters],
    queryFn: () => ConstructionReportsService.getCostReport(companyId, filters),
    enabled: !!companyId,
  });
}
